import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  listDemandProcurementMasters,
  updateDemandProcurementMaster,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 需要調達計画マスタ 更新 mutation hook。
 * optimistic locking: expected_updated_at を request に含める。
 * onSuccess で listDemandProcurementMasters を invalidate してテーブルを最新化する。
 */
export function useUpdateDemandProcurementMaster(): InvalidatingMutationResultFor<
  typeof updateDemandProcurementMaster
> {
  return useInvalidatingMutation(updateDemandProcurementMaster, [
    createConnectQueryKey({
      schema: listDemandProcurementMasters,
      cardinality: 'finite',
    }),
  ])
}
